new Vue({
  el: '#app',

  owCSS: `@font-face{font-family:Gentona;src:url(assets/fonts/Gentona-Book.eot);src:url(assets/fonts/Gentona-Book.woff) format("woff"),url(assets/fonts/Gentona-Book.otf),url(assets/fonts/Gentona-Book.ttf) format("truetype");font-weight:400;font-display:swap}@font-face{font-family:Gentona;src:url(assets/fonts/Gentona-Medium.eot);src:url(assets/fonts/Gentona-Medium.woff) format("woff"),url(assets/fonts/Gentona-Medium.otf),url(assets/fonts/Gentona-Medium.ttf) format("truetype");font-weight:500;font-display:swap}@font-face{font-family:Gentona;src:url(assets/fonts/Gentona-Light.eot);src:url(assets/fonts/Gentona-Light.woff) format("woff"),url(assets/fonts/Gentona-Light.otf),url(assets/fonts/Gentona-Light.ttf) format("truetype");font-weight:300;font-display:swap}.pull-right{float:right}.pull-left{float:left}.clearfix:after{display:block;content:"";clear:both}body,html{width:100%}.h-inherit,body,html{height:100%}`,
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "shell"
    }, [_c('router-view', {
      staticClass: "view"
    }), _vm._v(" "), (_vm.owRegistry['ola-styles']) ? _c('ola-styles') : _vm._e()], 1)
  },
  staticRenderFns: [],

  router: router,
  store: store

});